import DirectApproveDamexPage from '@/features/emailAction/routes/DirectApproveDamexPage'

const email_action_routes = [
  {
    breadcrumb: 'Direct Approve Damex',
    path: 'email-action/direct-approve-damex',
    element: <DirectApproveDamexPage />,
    children: [],
  },
]

export default email_action_routes
